// WhyChoose.jsx
import React from 'react';

export default function WhyChoose() {
    const features = [
        {
            title: 'Save More',
            description: 'Our passes help you save compared to individual ticket prices.'
        },
        {
            title: 'Experience More',
            description: 'Discover curated local adventures across the Emerald Coast, handpicked just for you.'
        },
        {
            title: 'Always Easy',
            description: 'One pass. One price. All your favorite activities in one place - no hassle, no stress.'
        }
    ];

    return (
        <section className="why-choose">
            <h2>Why Choose Beach Bum Pass?</h2>
            <div className="why-choose-grid">
                {features.map((item, index) => (
                    <div key={index} className="why-card">
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}